export {
    Type,
    instanceOf,
    toString,
    JSON_DISCRIMINATOR,
    Serializable,
    toTypedJSON,
    toUnwrappedJSON,
    fromTypedJSON,
    fromJSON,
    fromStringUnchecked,
    fromString,
    fromContractName,
} from '../../types/InitName.js';
